import React, { forwardRef } from 'react'
import * as SliderPrimitive from '@radix-ui/react-slider'

import styles from './ReactSlider.module.scss'

const SliderPrimitiveRoot = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <SliderPrimitive.Root {...itemProps} ref={forwardedRef} className={`${styles.SliderRoot} ${className || ''}`} />
  )
}

const SliderPrimitiveTrack = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <SliderPrimitive.Track {...itemProps} ref={forwardedRef} className={`${styles.SliderTrack} ${className || ''}`} />
  )
}

const SliderPrimitiveRange = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <SliderPrimitive.Range {...itemProps} ref={forwardedRef} className={`${styles.SliderRange} ${className || ''}`} />
  )
}

const SliderPrimitiveThumb = (props, forwardedRef) => {
  const { className, ...itemProps } = props

  return (
    <SliderPrimitive.Thumb {...itemProps} ref={forwardedRef} className={`${styles.SliderThumb} ${className || ''}`} />
  )
}

export const SliderRoot = forwardRef(SliderPrimitiveRoot)
export const SliderTrack = forwardRef(SliderPrimitiveTrack)
export const SliderRange = forwardRef(SliderPrimitiveRange)
export const SliderThumb = forwardRef(SliderPrimitiveThumb)
